// @flow

// Libs
import React, { PureComponent } from 'react'
import _size from 'lodash/size'

// Utils
import traverse from 'fc-utils/traverse'

// Components
import ArrowForwardIcon from 'fc-icons/src/ArrowForward'
import ArrowBackIcon from 'fc-icons/src/ArrowBack'
import { Link } from 'react-router-dom'
import SearchIcon from 'fc-icons/src/Search'

// Constants
import { MAP_ROUTE_ASSETS_TAB, MAP_ROUTE_JOBS_TAB, MAP_ROUTE_SEARCH_TAB } from '../../src/constants'

// Styles
import { dark, primary, notAsDarkGrey } from 'hfty-styles/src/colors'

// Local Utils
const path = traverse(['location', 'pathname'], { default: '' })

// Props
export type Props = {
  panelToggled: boolean,
  togglePanel: Function,
  children: any,
  onCancelJob: Function,
  onCancelEditSelectedField: Function,
  jobOperations: Object,
  featureOperation: Object,
}

// Local Styles
const styles = {
  containerWrapper: ({ toggled }: Object): Object => ({
    position: 'absolute',
    top: 0,
    right: 'initial',
    left: 0,
    bottom: 0,
    width: 375,
    maxWidth: '100vw',
    zIndex: 401,
    transform: `translateX(${toggled ? 0 : -350}px)`,
    willChange: 'transform',
    transition: 'transform 0.1s ease-in-out',
    color: dark(),
  }),
  container: {
    backgroundColor: '#f3f3f3',
    position: 'absolute',
    top: 0,
    right: 'initial',
    left: 0,
    bottom: 0,
    width: 350,
    display: 'flex',
    maxWidth: '100vw',
    zIndex: 401,
    color: dark(),
    flexDirection: 'column',
    overflowX: 'hidden',
    overflowY: 'auto',
    boxSizing: 'border-box',
  },
  togglePanelTab: ({ toggled }: Object): Object => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    width: 25,
    marginTop: -15,
    height: 30,
    backgroundColor: 'white',
    right: 0,
    top: '50%',
    borderTopRightRadius: '50%',
    borderBottomRightRadius: '50%',
    cursor: 'pointer',
    paddingRight: 2,
    transition: 'transform ease-in-out 0.2s',
    transform: `scale(${toggled ? 1 : 1.5})`,
    willChange: 'transform',
    boxShadow: '0 0 2px rgba(0, 0, 0, 0.2)',
  }),
  link: {
    display: 'inline-block',
    width: 'auto',
    minWidth: 'auto',
    lineHeight: '48px',
  },
  nav: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    width: '100%',
  },
  toggleTab: {
    display: 'inline-block',
    width: 'auto',
    minWidth: 'auto',
    lineHeight: '48px',
    textDecoration: 'none',
    color: notAsDarkGrey(),
  },
  currentActivetab: {
    display: 'inline-block',
    width: 'auto',
    minWidth: 'auto',
    lineHeight: '48px',
    textDecoration: 'none',
    borderBottom: `3px solid ${primary()}`,
    color: primary(),
  },
  icon: {
    display: 'block',
    marginTop: 5,
    marginBottom: 2,
  },
  mdcTab: {
    fontSize: 14,
    color: notAsDarkGrey(),
  },
}

// Exports
export class Drawer extends PureComponent {
  props: Props

  componentWillUnmount() {
    this.cancelJobsOperations()
    this.cancelFeatureOperation()
  }

  cancelJobsOperations() {
    const { onCancelJob, jobOperations } = this.props

    if (_size(jobOperations)) {
      onCancelJob(jobOperations)
    }
  }

  cancelFeatureOperation() {
    const { onCancelEditSelectedField, featureOperation } = this.props

    if (_size(featureOperation)) {
      onCancelEditSelectedField(featureOperation)
    }
  }

  clickTabHandler(activeTab: string) {
    switch (activeTab) {
      case MAP_ROUTE_ASSETS_TAB:
        this.cancelJobsOperations()
        break
      case MAP_ROUTE_JOBS_TAB:
        this.cancelFeatureOperation()
        break
      case MAP_ROUTE_SEARCH_TAB:
        this.cancelJobsOperations()
        this.cancelFeatureOperation()
        break
    }
  }

  render(): React.element<any> {
    const Arrow = this.props.panelToggled ? ArrowBackIcon : ArrowForwardIcon

    return (
      <div style={styles.containerWrapper({ toggled: this.props.panelToggled })}>
        <div onClick={this.props.togglePanel} style={styles.togglePanelTab({ toggled: this.props.panelToggled })}>
          <Arrow size={16} color={dark()} />
        </div>
        <div style={styles.container}>
          <nav id="basic-tab-bar" className="mdc-tab-bar" style={styles.nav}>
            <Link
              style={'/map' === path(this.props) ? styles.currentActivetab : styles.toggleTab}
              onClick={() => {
                this.clickTabHandler(MAP_ROUTE_ASSETS_TAB)
              }}
              to={MAP_ROUTE_ASSETS_TAB}
            >
              {'Farms & Fields'}
            </Link>
            <Link
              style={'/map/jobs' === path(this.props) ? styles.currentActivetab : styles.toggleTab}
              onClick={() => {
                this.clickTabHandler(MAP_ROUTE_JOBS_TAB)
              }}
              to={MAP_ROUTE_JOBS_TAB}
            >
              {'Jobs'}
            </Link>
            <Link
              style={'/map/search' === path(this.props) ? styles.currentActivetab : styles.toggleTab}
              onClick={() => {
                this.clickTabHandler(MAP_ROUTE_SEARCH_TAB)
              }}
              to={MAP_ROUTE_SEARCH_TAB}
            >
              <SearchIcon color={'/map/search' === path(this.props) ? primary() : dark()} style={styles.icon} />
            </Link>
            <span className="mdc-tab-bar__indicator" />
          </nav>
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default Drawer
